import { MenuItem, InputLabel } from '@material-ui/core';
import React from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { SettingsSelect } from '../../../../BranchDetails/components/BranchComponents';

const Dropdown = ({ value, items, onChangeEvent, onChange, name, label, disabled }) => {
  const handleChange = e => {
    const { value } = e.target;
    onChange?.(value);
    onChangeEvent?.(e);
  };

  return (
    <Container>
      <InputLabel style={{ paddingBottom: '8px' }}>{label}</InputLabel>
      <SettingsSelect
        label={label}
        name={name}
        displayEmpty
        onChange={handleChange}
        value={String(value)}
        disabled={disabled}
      >
        <MenuItem value=''>
          Not selected
        </MenuItem>
        {items?.length && items.map(({ title, value }) => (
          <MenuItem key={value} value={value}>
            {title}
          </MenuItem>
        ))}
      </SettingsSelect>
    </Container>
  );
};

const Container = styled(Flex)`
  padding-top: 20px;
  flex-direction: column;
`;

export default Dropdown;
